import React from 'react'
import _ from 'lodash'
import {
  GoogleMap,
  Marker,
  withGoogleMap,
  withScriptjs,
} from 'react-google-maps'
import { compose, withProps } from 'recompose'

const googleApi = 'AIzaSyDMqFgvXGC3lPZ-1ZL4iBOTnomoIWMImn4'

const MapView = ({
  defaultCenter = { lat: -34.397, lng: 150.644 },
  defaultZoom = 15,
  markers,
  center,
  isMarkerShown = true,
  onMarkerDragEnd,
  onMapClick,
}) => (
  <GoogleMap
    defaultZoom={defaultZoom}
    defaultCenter={defaultCenter}
    center={center || defaultCenter}
    onClick={onMapClick}
  >
    {isMarkerShown &&
      _.map(markers, ({ position }) => (
        <Marker
          key={position.lat + position.lng}
          position={position}
          draggable={true}
          onDragEnd={onMarkerDragEnd}
        />
      ))}
  </GoogleMap>
)

export default compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${googleApi}&libraries=places&language=th&region=TH`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap,
)(MapView)



// WEBPACK FOOTER //
// ./src/modules/map/MapView.js